import axios from '@/libs/axios'
import crudActions from '@/store/crudActions'

const fetchDirections = ({ commit }) => axios.get('/directions/', { params: { limit: 9999 } })
  .then(response => {
    commit('SET_DIRECTIONS', response.data.results || response.data)
    return response
  })

const fetchCategorySubjects = ({ commit }) => axios.get('/category-subjects/', { params: { limit: 9999 } })
  .then(response => {
    commit('SET_CATEGORY_SUBJECTS', response.data.results || response.data)
    return response
  })

export default {
  ...crudActions('direction-sector-codes'),
  fetchDirections,
  fetchCategorySubjects,
}
